<template>
    <div class="picture-library-wrapper">
        <Tabs class="picture-tabs" :tabsConfig="tabsConfig" @tabClick="tabClick">
            <component :is="currentComponentName" :refercence="refercence" :isSingle="isSingle" @checkClick="checkHandler" />
        </Tabs>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import VLinkPicture from "./components/VLinkPicture";

export default {
    name: "PictureLibraryPage",
    props: ["refercence", "isSingle"],
    components: {
        Tabs,
        VLinkPicture,
    },
    data() {
        return {
            currentComponentName: "VLinkPicture"
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.materialLibrary.vlinkPic"),
                    contentName: "VLinkPicture"
                }
            ];
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponentName = data.componentName;
            this.$emit("tabClick", data);
        },
        checkHandler(data) {
            this.$emit("checkClick", data);
        }
    }
};
</script>

<style scoped lang="less">
.picture-library-wrapper {
    background: #f2f7fb;
    height: 100%;
    box-sizing: border-box;
    .picture-tabs {
        width: 100%;
    }
    .test-input {
        margin: 10px;
        height: 226px;
        width: 500px;
    }
}
</style>
